var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTimermin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.75 5a.75.75 0 01-1.493.102L11.25 5V3a.75.75 0 01.75-.75c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12a9.72 9.72 0 012.847-6.886.75.75 0 011.062 1.06 8.25 8.25 0 106.592-2.39L12.75 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.474 7.596a.3.3 0 01.406-.122l5.06 2.725-.024.022a2 2 0 11-2.722 2.638l-.026.025L7.474 7.88a.3.3 0 010-.284z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimermin);
export default __webpack_public_path__ + "static/media/ic_timer.min.6ab16fcd.svg";
export { ForwardRef as ReactComponent };